module.exports = __webpack_public_path__ + "img/_1.623d0495.png";